import React from 'react';
import {StyledHeader1, RatingStyle, CaptionStyle, StyledButton} from "./styled_components";
import {PhoneCaptureFormProps} from "./types"
import {E164Number} from 'libphonenumber-js/core';
import StarRating from './components/StarRating';
import PhoneInput, {isValidPhoneNumber} from 'react-phone-number-input';
import 'react-phone-number-input/style.css'
import './styles.css';
import {submitVisitorData} from '../../../../packages/website/src/api'

const PhoneCaptureForm = (props: PhoneCaptureFormProps) => {
    const {title,
        rating,
        caption,
        formPlaceholder,
        buttonText,
        campaign,
        appDownloadLink,
        node_locale} = props;
    const [phone, setPhone] = React.useState<E164Number>()
    const isValid = !phone || isValidPhoneNumber(phone)
    const [success, setSuccess] = React.useState(false)
    const [failure, setFailure] = React.useState(false)
    const successMessage = "You will receive a link to download the app shortly!"
    const internalErrorMessage = "Something went wrong! Please try again."
    const invalidPhoneMessage = "Please enter a valid phone number!"
    const disclaimerMessage = "By providing your phone number, you consent to receive a one-time automated SMS message from Sezzle containing a link to download our app. Message and data rates may apply."

    const handleButtonClick = async (e) => {
        e.preventDefault();
        if (!phone || !isValid) {
            alert(invalidPhoneMessage)
        } else {
            const currentPageURL = window.location.href;
            const data = {
                "phone_number": phone,
                "current_page_url": currentPageURL,
                "campaign": campaign,
                "app_download_link": appDownloadLink,
            };

            try {
                await submitVisitorData(data);
                setSuccess(true);
            } catch (error) {
                setFailure(true);
            }
        }
    };
    
    return (
        <div className="wrapper" style={{borderRadius:"10px", width:"80%", backgroundColor:"rgba(244,244,244,255)"}}>
            <StyledHeader1>{title}</StyledHeader1>
            <div className="rating_container" style={{display:"inline-block", lineHeight: "1"}}>
                <RatingStyle>{rating}</RatingStyle>
                <StarRating rating={rating} /> 
                <CaptionStyle style={{paddingLeft:"10px"}}>{caption}</CaptionStyle>
            </div>
            {
                failure ? 
                (<CaptionStyle style={{marginTop:"0px"}} dangerouslySetInnerHTML={{ __html: internalErrorMessage }}></CaptionStyle>) :
                (success ?
                    (<CaptionStyle style={{marginTop:"0px"}}>{successMessage}</CaptionStyle>) : 
                    (<div className="form">
                        <form style={{display:"inline-block", paddingLeft:"20px", paddingBottom:"15px"}}>
                            <div style={{ display: "inline-flex", alignItems: "center" }}>
                                <PhoneInput
                                    placeholder={formPlaceholder}
                                    value={phone}
                                    onChange={setPhone}
                                    defaultCountry={(node_locale === 'en-US') ? 'US' : 'CA'}
                                    countries={['US','CA']}
                                    addInternationalOption={false}
                                    className={`phone-input ${isValid ? '' : 'invalid'}`}
                                />
                                <StyledButton onClick={handleButtonClick}>{buttonText}</StyledButton>
                            </div>
                        </form>
                        <CaptionStyle style={{paddingRight:"30px", fontSize:"10px"}}>{disclaimerMessage}</CaptionStyle>
                    </div>
                    )
                )
            }
        </div>
    );
}

export default PhoneCaptureForm;